import { useState } from 'react'
import { useTranslation } from 'react-i18next'

import { ReactComponent as Cancel } from '../../../assets/icons/close.svg'
import { ReactComponent as Save } from '../../../assets/icons/save.svg'
import { useUsersStore } from '../../../stores/usersStore'
import { IRoleEnum } from '../../../types/router'
import RoleSelect from '../RoleSelect/RoleSelect'

import styles from '../User/user.module.scss'

interface IEditUserProps {
    id: string
    name: string
    email: string
    role: IRoleEnum
    endEditing: () => void
}

function EditUser(props: IEditUserProps) {
    const { id, name, email, role, endEditing } = props

    const { t } = useTranslation()

    const [, { editUser }] = useUsersStore()

    const [newRole, setNewRole] = useState<IRoleEnum>(role)

    const handleSave = () => {
        editUser(id, newRole)
        endEditing()
    }

    const handleCancel = () => {
        endEditing()
    }

    return (
        <>
            <div className={styles.user__data}>
                <div className={styles.user__}>{name}</div>
                <div className={styles.user__}>{email}</div>
                <RoleSelect
                    className={styles.user__select}
                    role={newRole}
                    setRole={setNewRole}
                />
            </div>
            <div className={styles.user__buttons}>
                <button className={styles.user__btn} onClick={handleCancel}>
                    <Cancel className={styles.user__icon} alt={t('cancel')} />
                </button>
                <button className={styles.user__btn} onClick={handleSave}>
                    <Save className={styles.user__icon} alt={t('save')} />
                </button>
            </div>
        </>
    )
}

export default EditUser
